import { Accordion } from '@/components/AccordionSideMenu';
import { CtaLink } from '@/components/NewHeader/CtaLink';
import {
  BackButton,
  BigContent,
  Item,
  SmallContent,
} from '@/components/NewHeader/SideMenu/helperComponents';
import { useTranslation } from '@/contexts/dictionaryContext';
import useGTMEvents from '@/hooks/useGTMEvents';
import { useState } from 'react';

export function Experiences() {
  const {
    newHeader: { experiences, nav },
  } = useTranslation();
  const [value, setValue] = useState(experiences.foodExperiences.title);

  const { sendMenuClickEvent } = useGTMEvents();

  const section =
    nav.find((item) => item.id === 'experiences')?.title || 'Experiences';

  const handleItemClick = (item: { title: string; href: string }) =>
    sendMenuClickEvent({ section, sectionItem: item.title });

  return (
    <>
      <BackButton />

      <Accordion
        type="single"
        collapsible
        className="w-full bg-black/5"
        value={value}
        onValueChange={setValue}>
        <Item
          value={experiences.foodExperiences.title}
          isOpen={value === experiences.foodExperiences.title}>
          <BigContent
            onItemClick={handleItemClick}
            items={experiences.foodExperiences.items}
          />
        </Item>

        <Item
          value={experiences.privateTours.title}
          isOpen={value === experiences.privateTours.title}>
          <SmallContent
            onItemClick={handleItemClick}
            items={experiences.privateTours.items}>
            <CtaLink
              onClick={() =>
                sendMenuClickEvent({
                  section,
                  sectionItem: experiences.privateTours.cta.title,
                })
              }
              href={experiences.privateTours.cta.href}>
              {experiences.privateTours.cta.title}
            </CtaLink>
          </SmallContent>
        </Item>

        <Item
          value={experiences.privateTransfers.title}
          isOpen={value === experiences.privateTransfers.title}>
          <SmallContent
            onItemClick={handleItemClick}
            items={experiences.privateTransfers.items}
          />
        </Item>

        <Item
          value={experiences.outdoorActivities.title}
          isOpen={value === experiences.outdoorActivities.title}>
          <SmallContent
            onItemClick={handleItemClick}
            items={experiences.outdoorActivities.items}>
            <CtaLink
              onClick={() =>
                sendMenuClickEvent({
                  section,
                  sectionItem: experiences.outdoorActivities.cta.title,
                })
              }
              href={experiences.outdoorActivities.cta.href}>
              {experiences.outdoorActivities.cta.title}
            </CtaLink>
          </SmallContent>
        </Item>

        <Item
          value={experiences.wineTours.title}
          isOpen={value === experiences.wineTours.title}>
          <SmallContent
            onItemClick={handleItemClick}
            items={experiences.wineTours.items}>
            <CtaLink
              onClick={() =>
                sendMenuClickEvent({
                  section,
                  sectionItem: experiences.wineTours.cta.title,
                })
              }
              href={experiences.wineTours.cta.href}>
              {experiences.wineTours.cta.title}
            </CtaLink>
          </SmallContent>
        </Item>
      </Accordion>

      <div className="p-4">
        <CtaLink
          onClick={() =>
            sendMenuClickEvent({
              section,
              sectionItem: experiences.cta.title,
            })
          }
          href={experiences.cta.href}>
          {experiences.cta.title}
        </CtaLink>
      </div>
    </>
  );
}
